import React, { useContext, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DeckContext } from '../../context/DeckContext';
import BaseBlock from './BaseBlock';
import EdgeIndicator from './EdgeIndicator';

import { formatFeetInches } from '../../utils/measurementUtils';
import { BumpoutBlockProps } from '../../../../../../types/shared/props';
import EDGE_WIDTH from '../../../../../../constants/edgeWidth';

const Bumpout: React.FC<BumpoutBlockProps> = ({
	label,
	bumpout,
	onSelect,
	onUpdateBlock,
	setIsDragging,
}) => {
	const { state, dispatch } = useContext(DeckContext);
	const nodeRef = useRef(null);
	const { scaleFactor } = state;

	return (
		<BaseBlock
			block={bumpout}
			onSelect={onSelect}
			onUpdateBlock={onUpdateBlock}
			setIsDragging={setIsDragging}
			disabled={false}
			nodeRef={nodeRef}
		>
			<Box
				ref={nodeRef}
				style={{ transform: `rotate(${bumpout.rotation || 0}deg)` }}
				sx={{
					width: bumpout.displayDimensions.width * scaleFactor,
					height: bumpout.displayDimensions.height * scaleFactor,
					bgcolor: '#03A9F4',
					cursor: 'pointer',
					position: 'absolute',
					zIndex: '10',
				}}
			>
				<Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
					{/* Edge Indicators */}
					{bumpout.edges.map((edge) => (
						<EdgeIndicator
							key={edge.label}
							position={edge.label.toLowerCase()}
							label={edge.label}
							type={edge.type}
							length={edge.length}
							onSelectEdge={(label) => {
								dispatch({
									type: 'SELECT_EDGE',
									payload: { blockId: bumpout.id, edgeLabel: label },
								});
							}}
							isSelected={
								state.selectedEdge?.blockId == bumpout.id &&
								state.selectedEdge?.edgeLabel === edge.label
							}
							parentIsSelected={state.selectedBlock?.id === bumpout.id}
						/>
					))}

					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: 'center',
							paddingTop: `${EDGE_WIDTH}px`,
							cursor: 'pointer',
						}}
					>
						<Typography
							variant="caption"
							position="absolute"
							lineHeight={1.15}
							color="rgba(0, 0, 0, 0.6)"
							noWrap
							zIndex={10}
						>
							<p>
								<b>{label}</b>
							</p>
							{formatFeetInches(bumpout.dimensions.depth)}
							<span className="px-0.5">&times;</span>
							{formatFeetInches(bumpout.dimensions.width)}
						</Typography>
					</Box>
				</Box>
			</Box>
		</BaseBlock>
	);
};

export default Bumpout;
